import { URI } from '@vscode-alt/monaco-editor/esm/vs/base/common/uri';
import { ICodeEditor, IDiffEditor } from '@vscode-alt/monaco-editor/esm/vs/editor/browser/editorBrowser';
import { IDecorationRenderOptions } from '@vscode-alt/monaco-editor/esm/vs/editor/common/editorCommon';
import { IModelDecorationOptions, ITextModel } from '@vscode-alt/monaco-editor/esm/vs/editor/common/model';
import { IResourceEditorInput as IResourceInput } from '@vscode-alt/monaco-editor/esm/vs/platform/editor/common/editor';
import { StaticServices } from '@vscode-alt/monaco-editor/esm/vs/editor/standalone/browser/standaloneServices';
import { injectable } from 'inversify';
import { ICodeEditorService } from '@workbench-stack/core';
import { Event } from '@vscode-alt/monaco-editor/esm/vs/base/common/event';

@injectable()
export class CodeEditorService implements ICodeEditorService {
    onDecorationTypeRegistered: Event<string>;
    resolveDecorationCSSRules(decorationTypeKey: string): CSSRuleList {
        throw new Error("Method not implemented.");
    }
    setModelProperty(resource: URI, key: string, value: any): void {
        throw new Error("Method not implemented.");
    }
    getModelProperty(resource: URI, key: string) {
        throw new Error("Method not implemented.");
    }
    getTransientModelProperties(model: ITextModel): [string, any][] {
        throw new Error("Method not implemented.");
    }

    public addCodeEditor(editor: ICodeEditor): void {
        return StaticServices.codeEditorService.get().addCodeEditor(editor);
    }
    public removeCodeEditor(editor: ICodeEditor): void {
        return StaticServices.codeEditorService.get().removeCodeEditor(editor);
    }
    public listCodeEditors() {
        return StaticServices.codeEditorService.get().listCodeEditors();
    }

    public addDiffEditor(editor: IDiffEditor): void {
        return StaticServices.codeEditorService.get().addDiffEditor(editor);
    }
    public removeDiffEditor(editor: IDiffEditor): void {
        return StaticServices.codeEditorService.get().removeDiffEditor(editor);
    }
    public listDiffEditors() {
        return StaticServices.codeEditorService.get().listDiffEditors();
    }

    /**
     * Returns the current focused code editor (if the focus is in the editor or in an editor widget) or null.
     */
    public getFocusedCodeEditor(): ICodeEditor | null {
        return StaticServices.codeEditorService.get().getFocusedCodeEditor();
    }

    public registerDecorationType(key: string, options: IDecorationRenderOptions, parentTypeKey?: string): void {
        return StaticServices.codeEditorService.get().registerDecorationType(key, options, parentTypeKey);
    }
    public removeDecorationType(key: string): void {
        return StaticServices.codeEditorService.get().removeDecorationType(key);
    }
    public resolveDecorationOptions(typeKey: string, writable: boolean): IModelDecorationOptions {
        return StaticServices.codeEditorService.get().resolveDecorationOptions(typeKey, writable);
    }

    public setTransientModelProperty(model: ITextModel, key: string, value: any): void {
        return StaticServices.codeEditorService.get().setTransientModelProperty(model, key, value);
    }
    public getTransientModelProperty(model: ITextModel, key: string): any {
        return StaticServices.codeEditorService.get().getTransientModelProperty(model, key);
    }

    public getActiveCodeEditor(): ICodeEditor | null {
        return StaticServices.codeEditorService.get().getActiveCodeEditor();
    }
    public openCodeEditor(input: IResourceInput, source: ICodeEditor | null, sideBySide?: boolean): Promise<ICodeEditor | null> {
        return StaticServices.codeEditorService.get().openCodeEditor(input, source, sideBySide);
    }

}
